import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { HttpData } from "../../../../Core";

export default function ProductSubtypeModalCreate({
  jwt,
  show,
  onHide,
  onCreated,
}) {
  const [name, setName] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    const response = await HttpData(
      "/api/v1/calculateOrderCost/productSubtypes",
      "POST",
      jwt,
      {
        name: name,
      },
    );

    if (response.statusSuccessful) {
      onCreated(response.data);
      setName("");
    } else {
      alert(`Не получилось создать: ${response.error}`);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={onSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Создание подтипа</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Название</Form.Label>
            <Form.Control
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Отмена
          </Button>
          <Button variant="success" type="submit">
            Создать
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
